import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';

import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Spacer from 'components/ui/Spacer';
import TextBox from 'components/ui/TextBox';

const FullWidthTextArea = styled(TextBox.TextArea)`
  width: 100%;
`;

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const StyledSectionContainer = styled.div`
  margin-bottom: 32px;
`;

const Comments = ({ errors, touched, handleChange, mode, showResidentsComments, readOnly }) => {
  return (
    <Fragment>
      {mode === 'create' && (
        <Fragment>
          <InternalComments
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            readOnly={readOnly}
          />
          {showResidentsComments && (
            <ResidentComments handleChange={handleChange} errors={errors} touched={touched} />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

const mapStoreToProps = store => ({
  showResidentsComments: store.companyDetails.companyPreferences.active_tenant_portal,
});
const mapDispatchToProps = {};

export default connect(mapStoreToProps, mapDispatchToProps)(Comments);

const InternalComments = ({ errors, touched, handleChange, readOnly }) => (
  <StyledSectionContainer>
    <Spacer mb={0.3}>
      <FormTitle>
        {getTranslatedString('landlordPortal.maintenance.comments.internalComments')}
      </FormTitle>
    </Spacer>
    <Row gutter={16}>
      <Col span={24}>
        <Form.Item
          label={`${getTranslatedString('landlordPortal.maintenance.comments.comment')}`}
          validateStatus={touched.internal_notes && errors.internal_notes ? 'error' : null}
          help={touched.internal_notes && errors.internal_notes}
        >
          <FullWidthTextArea
            placeholder={getTranslatedString(
              'landlordPortal.maintenance.comments.internal.placeholder'
            )}
            size="large"
            name="internal_notes"
            disabled={readOnly}
            onChange={handleChange}
          />
        </Form.Item>
      </Col>
    </Row>
  </StyledSectionContainer>
);

const ResidentComments = ({ errors, touched, handleChange }) => (
  <StyledSectionContainer>
    <Spacer mb={0.3}>
      <FormTitle>
        {getTranslatedString('landlordPortal.maintenance.comments.residentComments')}
      </FormTitle>
    </Spacer>
    <Row gutter={16}>
      <Col span={24}>
        <Form.Item
          label={`${getTranslatedString('landlordPortal.maintenance.comments.comment')}`}
          validateStatus={touched.notes_to_tenant && errors.notes_to_tenant ? 'error' : null}
          help={touched.notes_to_tenant && errors.notes_to_tenant}
        >
          <FullWidthTextArea
            placeholder={getTranslatedString(
              'landlordPortal.maintenance.comments.resident.placeholder'
            )}
            size="large"
            name="notes_to_tenant"
            onChange={handleChange}
          />
        </Form.Item>
      </Col>
    </Row>
  </StyledSectionContainer>
);
